<template>
    <div class="list-thum">
        <ul>
            <li v-for="(item,index) in list" :key="index" class="item am-cf">
                <div class="image" v-if="item.first_img">
                     <div class="img" :style="'background-image:url('+(item.first_img==''?'static/img/nopic.gif':item.first_img)+')'">
                     </div>
                </div>
                <div class="text" :style="{width:(item.first_img?' calc(100% - 200px)':' calc(100% - 80px)')}">
                    <div class="title">
                        <el-tag size="mini" v-if="item.port_new=='1'">新</el-tag>
                        <el-tag size="mini" v-if="item.port_top=='1'" type="danger">顶</el-tag>
                        <router-link :to="'/article/'+item.article_id" target="_blank">{{item.title}}</router-link>
                    </div>
                    <div class="detail">
                        {{item.context.substring(0,80)}}
                        <span v-if="item.context.length>80">...</span>
                    </div>
                </div>
                <div class="date">
                    <div class="day">{{(item.publish_time||'').substring(5,10)}}</div>
                    <div class="year">{{(item.publish_time||'').substring(0,4)}}</div>
                </div>
            </li>
        </ul>
        <div class="no-data" v-if="!list.length">暂无文章</div>
    </div>
</template>

<script>
    export default {
         props:{
             list:{
                 type:Array,
                 default:[],
             },
             date:{
                 type:Boolean,
                 default:true,
             }
         },
    }
</script>

<style lang="scss">
.list-thum{
    margin: 20px 0;
    .item{
        padding-bottom: 12px;
        border-bottom: 1px solid rgb(223, 223, 223);
        margin-bottom: 20px;
        &:last-child{
            border-bottom: none;
        }
        .image{
            width: 120px;
            float: left;
            .img{
            padding-bottom: 80%;
            }
        }
        
        .border{
            padding: 0;
            transition: .3s;
        }
        .text{
            padding-left: 16px;
            box-sizing: border-box;
            float: left;
            .title{
            margin:0px 0 16px 0;
            font-size: 17px;
           a{ font-weight: bold;}
            color: #5a5a55;
            &:hover{
                color: $primary;
            }
        }
        .detail{
            font-size: 10px;
            font-size: 13px;
            font-family: "SimSun";
            color: #5a5a55;
            line-height: 1.6;
            font-family: simsun;
            text-align: justify;
        }

        }
        
        .date{
             float: left;
            width:80px;
            padding-left: 12px;
            box-sizing: border-box;
.day{
            margin-top: 24px;
            font-size: 16px;
            margin-bottom: 4px;
            color: #b4b0aa;
            text-align: left;
        }
        .year{
            text-align: left;
            color: #b4b0aa;
            font-size: 12px;
        }
        }

    }
    
}
</style>